import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { BooleanCheckOrCrossViewColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { DatalistviewComponent } from 'src/app/shared/datalistview/datalistview.component';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { DeleteCheckComponent } from 'src/app/shared/modals/delete-check/delete-check.component';
import { EditCitationExemptionListEntryComponent } from '../edit-entry/edit-citation-exemption-list-entry.component';

@Component({
    selector: 'app-edit-citation-exemption-list',
    templateUrl: './edit-citation-exemption-list.component.html',
    styleUrls: ['./edit-citation-exemption-list.component.scss'],
    standalone: false
})
export class EditCitationExemptionListComponent extends ModelEditor implements OnInit {

  @ViewChild(DatalistviewComponent)
  public ListView!: DatalistviewComponent;

  public CanWrite: boolean = false;

  public EntryColumns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Plate', 'PlateNumber'),
    new Datalistviewcolumn('Region Code', 'RegionCode'),
    new Datalistviewcolumn('Expires', 'ExpiresOnLocalFriendlyString'),
    new Datalistviewcolumn('Notes', 'Notes'),
  ];

  constructor(
    public route: ActivatedRoute,
    private injector: Injector,
    private toastr: ToastrService,
    private modalService: SimpleModalService,
    private permissionsService: PermissionsService
  ) {
    super('enforcement/citation-exemption-lists', injector);
  }

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.CanWrite = await this.permissionsService.CheckAdminPermission('EnforcementFeature', 500);
  }

  public DefaultModel() {
    return { Name: '', Description: '', IsActive: true, ExpiresOnLocal: null };
  }

  public AfterModelLoaded(): void {
    this.stripTimeFromDate('ExpiresOnLocal');
  }

  private stripTimeFromDate(name: string): void {
    const formControl = this.Form.get(name);
    if (formControl?.value) {
      const dateValue = formControl.value;
      if (typeof dateValue === 'string' && dateValue.includes('T')) {
        formControl.setValue(dateValue.split('T')[0], { emitEvent: false });
      }
    }
  }

  public override AfterSave(): void {
    super.AfterSave();
    this.ListView?.Refresh();
  }

  public BeforeSave(): boolean | void {
    return true;
  }

  public Validators() {
    return {
      Name: [Validators.required, Validators.minLength(1), Validators.maxLength(128)],
      Description: [Validators.maxLength(255)]
    };
  }

  public OpenEntry(item: any): void {
    this.modalService.addModal(EditCitationExemptionListEntryComponent, {
      Model: item ?? {},
      ListId: this.Model.Id
    }).subscribe(result => {
      if (result != null) {
        this.ListView?.Refresh();
      }
    });
  }

  public DeleteEntry(item: any): void {
    this.modalService.addModal(DeleteCheckComponent, {
      name: item.PlateNumber,
      url: `enforcement/citation-exemption-lists/${this.Model.Id}/entries/`,
      modelId: item.Id,
      SkipCheck: true,
      deleteNavLink: null
    }).subscribe(() => {
      this.ListView?.Refresh();
    });
  }
}
